import React from 'react';

import * as S from './styles';

const Header: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Photo />
      </S.Content>
      <S.Content className="right">
        <S.Title>Blow-up</S.Title>
        <S.Text>
          Cabelos arquitetônicos, clash de cores e traços geométricos remontam a
          beleza da década de 1960 e trazem um toque romântico para os mais
          interessantes visuais contemporâneos.
        </S.Text>
        <S.Credits>
          Fotos: Juliana Rocha
          <br />
          Beleza: Daniel Hernandez
          <br />
          Edição de beleza: Pedro Camargo
          <br />
          Edição de moda: Marcell Maia
        </S.Credits>
      </S.Content>
    </S.Container>
  );
};

export default Header;
